import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import type { SearchFilters } from '@@/bits/web_search'
import OzDivider, { OzDividerColorScheme } from '@@/library/v4/components/OzDivider.vue'
import OzTabs, { OzTabsPlacementMode } from '@@/library/v4/components/OzTabs.vue'
import { type ContentPickerSearchMode } from '@@/pinia/content_picker'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPickerSearchModes',
  props: {
    searchModes: null,
    currentSearchFilter: null
  },
  emits: ["filter-selected"],
  setup(__props: any, { expose, emit }: { emit: ({
  (name: 'filter-selected', filter: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  searchModes: ContentPickerSearchMode[]
  currentSearchFilter: SearchFilters
};





const displayedSearchModes = computed(() => props.searchModes.filter((mode) => mode.visible))

const isShook = ref<boolean>(false)

const shake = (): void => {
  isShook.value = false
  setTimeout(() => {
    isShook.value = true
  }, 1)
}

expose({
  shake,
})

return { __sfc: true,props, emit, displayedSearchModes, isShook, shake, __, OzDivider, OzDividerColorScheme, OzTabs, OzTabsPlacementMode }
}

})